import axios from "axios"

export const getGotoUrl = (baseUrl, { url }) => {
  const path = `${baseUrl}${url}`

  return axios.get(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }))
}
